export default '/build/ec6d161b.jpg'